import React from "react";
import LayerGroup from "../../../../types/LayerGroup";
import LayerLegend from "../sharedComponents/LayerLegend";
import LegendRow from "../sharedComponents/LegendRow";

class ForestsLegend extends React.PureComponent<{}, {}> {
  render() {
    return (
      <LayerLegend
        layerGroup={LayerGroup.Forests}
        classes="forests"
        legendRows={[
          <LegendRow
            color="#E6DA96"
            text="Forests"
          />
        ]}
      />
    );
  }
}

export default ForestsLegend;
